<template>
	<div>
		<div v-if="externalSource">
			<BrebImg :externalSource="externalSource" :styles="styles" :height="height" :width="width" :zoom="picZoom"
				:rounded="rounded" :key="1" />
			<a v-if="showLearnMore" :href="normalize(showLearnMore)" class="learn-more-button"
				style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); padding: 10px 20px; background-color: rgba(0, 0, 0, 0.6); color: white; text-decoration: none; border-radius: 5px;">
				Learn More
			</a>
		</div>
		<div v-else-if="!file">
			<BrebImg :externalSource="showPlaceHolder ? showPlaceHolder : iImage" :styles="styles" :height="height"
				:width="width" :zoom="picZoom" :rounded="rounded" :key="2" />
		</div>
		<div v-else-if="file.mime_type.startsWith('video/')" style="position: relative;">
			<BrebVideo v-if="file.status && file.status === 'QUARANTINE'" :file="file" :height="height" :styles="styles"
				:controls="controls" :showPlay="showPlay" :autoplay="autoplay" :loop="loop" :zoom="zoom"
				:showLogo="showLogo" :sharelink="sharelink" :key="3" />
			<BrebImg v-else-if="isQuarantined" :externalSource="imageProcessing" :styles="styles" :height="height"
				:width="width" :zoom="picZoom" :rounded="rounded" :key="4" />
			<BrebVideo v-else :file="file" :height="height" :styles="styles" :controls="controls" :showPlay="showPlay"
				:autoplay="autoplay" :loop="loop" :zoom="zoom" :showLogo="showLogo" :sharelink="sharelink" :key="5" />
			<!-- <BrebLoading :loading="file.status === 'QUARANTINE'" isComponent /> -->
		</div>
		<div flat v-else style="position: relative;">
			<BrebImg v-if="file.status && file.status === 'QUARANTINE'" :file="file" :styles="styles" :height="height"
				:width="width" :zoom="picZoom" :rounded="rounded" :key="6" />
			<BrebImg v-else-if="isQuarantined" :externalSource="imageProcessing" :styles="styles" :height="height"
				:width="width" :zoom="picZoom" :rounded="rounded" :key="7" />
			<BrebImg v-else :file="file" :styles="styles" :height="height" :width="width" :zoom="picZoom"
				:rounded="rounded" :key="8" />
			<a v-if="!isQuarantined && showLearnMore" :href="normalize(showLearnMore)"
				class="learn-more-button page-body"
				style="position: absolute; top: 60%; left: 50%; transform: translate(-50%, -50%); padding: 10px 20px; background-color: rgba(0, 0, 0, 0.6); color: white; text-decoration: none; border-radius: 5px;">
				Learn More <v-icon color="white">mdi-arrow-right</v-icon>
			</a>
			<!-- <BrebLoading :loading="file.status === 'QUARANTINE'" isComponent /> -->
		</div>
	</div>
</template>

<script>
import BrebImg from "@/components/accessory/BrebImg.vue";
import BrebVideo from "@/components/accessory/BrebVideo.vue";
const iImage = require("@/assets/default-images/image-icon2.png");
const vImage = require("@/assets/default-images/video-icon2.png");
const imageProcessing = require("@/assets/default-images/image-processing.png");
// import BrebLoading from '@/components/accessory/BrebLoading.vue';

export default {
	name: "BrebFile",
	components: {
		BrebImg,
		BrebVideo,
		// BrebLoading,
	},
	mixins: [],
	props: {
		file: {
			type: Object,
			// required: true,
		},
		externalSource: {
			type: String,
			default: '',
		},
		maxHeight: {
			type: String,
		},
		maxWidth: {
			type: String,
		},
		height: {
			type: [String],
			default: '100%',
		},
		width: {
			type: [String],
			default: '100%',
		},
		ratio: {
			type: String,
			default: () => '',
		},
		sharelink: {
			type: String,
			default: () => '',
		},
		zoom: {
			type: String,
			default: 'cover',
		},
		showLearnMore: {
			type: String,
			default: '',
		},
		showPlaceHolder: {
			type: String,
			default: '',
		},
		//Properties for image only
		rounded: {
			type: Boolean,
			default: false,
		},
		picZoom: {
			type: String,
			default: 'cover',
		},
		picStyle: {
			type: Object,
			default: () => { },
		},
		//Properties for video only
		controls: {
			type: Boolean,
			default: true,
		},
		showPlay: {
			type: Boolean,
			default: true
		},
		autoplay: {
			type: Boolean,
			default: false,
		},
		loop: {
			type: Boolean,
			default: false,
		},
		showLogo: {
			type: Boolean,
			default: true,
		},

	},
	data: function () {
		return {
			iImage,
			vImage,
			imageProcessing,
			isQuarantined: true,
		}
	},
	computed: {
		mobile() {
			return this.$vuetify.breakpoint.mobile
		},
		cellphone() {
			return this.$vuetify.breakpoint.xs
		},
		styles() {
			return {
				'max-height': this.maxHeight,
				'max-width': this.maxWidth,
				'aspect-ratio': this.aspectRatio,
				...this.picStyle,
			}
		},
		aspectRatio() {
			if (this.ratio === 'portrait') {
				return 3 / 4;
			} else if (this.ratio === 'logo') {
				return 3 / 2;
			} else if (this.ratio === 'photo') {
				return 1 / 1;
			} else if (this.ratio === 'image') {
				return 4 / 3;
			} else if (this.ratio === 'homepageSlider') {
				return 2 / 1;
			} else {
				return 'auto';
			}
		},
	},
	watch: {
		'file.quarantined': {
			deep: true,
			immediate: true,
			handler(v) {
				if (v && v === true) {
					this.isQuarantined = true;
				} else {
					this.isQuarantined = false;
				}
				this.$forceUpdate();
			}
		},
	},
	methods: {
		normalize(url) {
			if (url.startsWith('https://') || url.startsWith('http://')) {
				return url;
			} else {
				return `https://${url}`;
			}
		}
	},
	created() {

	},
	beforeMount() {

	},
	mounted() {

	},
	beforeDestroy() {

	},

}
</script>

<style scoped></style>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@import 'node_modules/vuetify/src/styles/settings/variables';
@import "src/globals";
@media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {}
</style>